import React, { useRef, useEffect } from 'react';

function TextEditor({ value, onChange, disabled, onKeyDown }) {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, []);

  return (
    <input
      ref={inputRef}
      type="text"
      className="field-editor-input"
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={onKeyDown}
      disabled={disabled}
    />
  );
}

export default TextEditor;
